import React from 'react';

const BS_Scrollspy = () => {
    return (
        <div>
            <h1>BS_Scrollspy Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Scrollspy;
